export default __webpack_public_path__ + "static/media/home-finance-industries-img-02.4ec81e20.jpg";